import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

/** Long replies still finish revealing within this time. */
const MAX_REVEAL_MS = 600;
const WORD_MS = 40;

const prefersReducedMotion = () =>
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

type Props = {
  text: string;
  /** False for replies that were already shown, e.g. when the modal reopens */
  animate: boolean;
  onDone: () => void;
};

/** A reply that appears word by word. */
const RevealingText: React.FC<Props> = ({ text, animate, onDone }) => {
  const words = text.split(" ");
  const instant = !animate || prefersReducedMotion();
  const [shown, setShown] = useState(instant ? words.length : 0);

  useEffect(() => {
    if (shown >= words.length) {
      if (animate) onDone();
      return;
    }
    const timer = setTimeout(
      () => setShown((n) => n + 1),
      Math.min(WORD_MS, MAX_REVEAL_MS / words.length)
    );
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shown, words.length]);

  return (
    <Typography
      variant="body1"
      aria-busy={shown < words.length}
      sx={{ color: "text.primary", whiteSpace: "pre-wrap" }}
    >
      {words.slice(0, shown).join(" ")}
    </Typography>
  );
};

export default RevealingText;
